const useEmailComponentViewConditions = ({
  currentEmailDetails,
  isLoading,
  listDomainsVerified,
  location,
  editorOnLoad,
}) => {
  const sentEmail = currentEmailDetails?.status === 'Sent' || currentEmailDetails?.status === 'PartiallySent';

  const disabledToCondition = sentEmail;

  const bodyCondition =
    (!isLoading || (isLoading && location?.state?.writingAssistantId)) &&
    (!!listDomainsVerified.verifiedDomains.length || !!listDomainsVerified.verifiedEmailAddresses.length) &&
    !listDomainsVerified.domainsProccessing;

  const skeletonCondition = isLoading || editorOnLoad || listDomainsVerified.domainsProccessing;

  return {
    sentEmail,
    disabledToCondition,
    bodyCondition,
    skeletonCondition,
  };
};

export default useEmailComponentViewConditions;
